import { useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

interface SimpleCalendarProps {
    selectedDate?: Date | null;
    onDateChange: (date: Date) => void;
}

const SimpleCalendar = ({ selectedDate, onDateChange }: SimpleCalendarProps) => {
    const [currentMonth, setCurrentMonth] = useState(selectedDate || new Date());

    const today = new Date();
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();

    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());

    const days = [];
    const current = new Date(startDate);

    for (let i = 0; i < 42; i++) {
        days.push(new Date(current));
        current.setDate(current.getDate() + 1);
    }

    const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

    const isToday = (date: Date) => {
        return date.toDateString() === today.toDateString();
    };

    const isSelected = (date: Date) => {
        if (!selectedDate) return false;
        return date.getFullYear() === selectedDate.getFullYear() &&
            date.getMonth() === selectedDate.getMonth() &&
            date.getDate() === selectedDate.getDate();
    };

    const isCurrentMonth = (date: Date) => {
        return date.getMonth() === month;
    };

    return (
        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg p-3">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
                <button
                    onClick={() => setCurrentMonth(new Date(year, month - 1))}
                    className="p-1 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
                >
                    <FiChevronLeft size={16} />
                </button>
                <span className="text-sm font-medium text-gray-900 dark:text-white">
                    {monthNames[month]} {year}
                </span>
                <button
                    onClick={() => setCurrentMonth(new Date(year, month + 1))}
                    className="p-1 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
                >
                    <FiChevronRight size={16} />
                </button>
            </div>

            {/* Week days */}
            <div className="grid grid-cols-7 gap-1 mb-2">
                {weekDays.map(day => (
                    <div key={day} className="text-xs text-gray-500 dark:text-gray-400 text-center py-1">
                        {day}
                    </div>
                ))}
            </div>

            {/* Days */}
            <div className="grid grid-cols-7 gap-1">
                {days.map((date, index) => (
                    <button
                        key={index}
                        onClick={() => {
                            // Criar nova data no timezone local para evitar problemas de fuso horário
                            const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                            onDateChange(localDate);
                        }}
                        className={`
                            text-xs p-2 rounded hover:bg-blue-100 dark:hover:bg-blue-900 transition-colors
                            ${!isCurrentMonth(date) ? 'text-gray-300 dark:text-gray-600' : 'text-gray-900 dark:text-white'}
                            ${isToday(date) ? 'bg-blue-100 dark:bg-blue-900 font-medium' : ''}
                            ${isSelected(date) ? 'bg-blue-600 text-white hover:bg-blue-700' : ''}
                        `}
                    >
                        {date.getDate()}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SimpleCalendar;
